import { ASSET_SIZE_STATUS } from '~/config/constants/asset'
import { TRANSITIONS } from '~/enums'

export function getTransitionDissolveInsertStatus(assets, leftAsset,
  rightAsset, transition, transitionDuration) {
  const rightExpandDuration = rightAsset?.mediaStart
  const leftExpandDuration = leftAsset?.mediaFileDuration
    - leftAsset?.duration - leftAsset?.mediaStart

  const existsFadeOutDuration = assets
    .find(a => [ TRANSITIONS.FADEOUT, TRANSITIONS.DISSOLVE ].includes(a.type)
    && a.leftVideoAssetId === rightAsset?.id)?.duration ?? 0
  const existsFadeInDuration = assets
    .find(a => [ TRANSITIONS.FADEIN, TRANSITIONS.DISSOLVE ].includes(a.type)
    && a.rightVideoAssetId === leftAsset?.id)?.duration ?? 0

  if (transition?.id) {
    if (leftExpandDuration >= (transitionDuration / 2)
        && rightExpandDuration >= (transitionDuration / 2)
        && rightAsset?.startTime - (transitionDuration / 2)
        >= leftAsset?.startTime + existsFadeInDuration) {
      return ASSET_SIZE_STATUS.LEFT_CUT_RIGHT_CUT
    }

    if (rightExpandDuration >= leftAsset?.duration
        && leftAsset?.duration <= (transitionDuration / 2)
        && (leftAsset?.duration + leftExpandDuration) >= transitionDuration
        && leftAsset?.endTime + (transitionDuration - leftAsset?.duration)
        <= rightAsset?.endTime - existsFadeOutDuration) {
      return ASSET_SIZE_STATUS.LEFT_CUT_RIGHT_CUT_ASYMMETRICAL
    }

    if (rightExpandDuration >= transitionDuration
        && rightAsset?.startTime - transitionDuration
        >= leftAsset?.startTime + existsFadeInDuration) {
      return ASSET_SIZE_STATUS.RIGHT_CUT_LEFT_NORMAL
    }

    if (leftExpandDuration >= transitionDuration
        && leftAsset?.endTime + transitionDuration
        <= rightAsset?.endTime - existsFadeOutDuration) {
      return ASSET_SIZE_STATUS.LEFT_CUT_RIGHT_NORMAL
    }

    return ASSET_SIZE_STATUS.NOT_CUT
  }
  return null
}
